import useIsLoggedIn from '@@/hooks/useIsLoggedIn';
import { useFeatureFlags } from '@@/services/useFeatureFlags';

import PhoneLink, { TPhoneLink } from '../PhoneLink';

export type TTenantPhoneLink = TPhoneLink;

export default function TenantPhoneLink(props: TPhoneLink) {
  const { isFeatureEnabled } = useFeatureFlags();
  const isLoggedIn = useIsLoggedIn();

  return isFeatureEnabled('isTenantPhoneNumberEnabled') && !isLoggedIn ? (
    <PhoneLink {...props} data-testid="tenant-phone-link" />
  ) : null;
}
